import type { ReactNode } from 'react';

/**
 * Peças visuais de "Sua adega em números" e de "Como está sua adega".
 *
 * Moradia própria porque as duas telas usam: a linha do tempo saiu do retrato
 * quando conselho e contagem viraram coisas separadas, e levou as barras
 * junto.
 */
export function Secao({ icone, titulo, children }: { icone: string; titulo: string; children: ReactNode }) {
  return (
    <section className="space-y-2.5">
      <h2 className="font-semibold">
        <span aria-hidden>{icone}</span> {titulo}
      </h2>
      {children}
    </section>
  );
}

/** Barras proporcionais ao maior valor da lista. */
export function Barras({ itens, cor }: { itens: Array<{ rotulo: string; valor: number }>; cor: string }) {
  const maior = Math.max(...itens.map((item) => item.valor), 1);
  return (
    <ul className="space-y-2">
      {itens.map((item) => (
        <li key={item.rotulo} className="grid grid-cols-[minmax(0,9.5rem)_1fr_1.5rem] items-center gap-2 text-sm">
          <span className="truncate">{item.rotulo}</span>
          <span className="h-2 overflow-hidden rounded-full bg-adega-surface-2" aria-hidden>
            <span
              className={`block h-full rounded-full ${cor}`}
              style={{ width: `${Math.round((item.valor / maior) * 100)}%` }}
            />
          </span>
          <span className="text-right tabular-nums">{item.valor}</span>
        </li>
      ))}
    </ul>
  );
}
